import gql from 'graphql-tag';

export default fileName => {
  const operatorDisputeRecon = `operatorDisputeRecon(fileName: "${fileName}")`;
  return gql`
    mutation {
      ${operatorDisputeRecon} {
        id
      }
    }
  `;
};
